






























































import Vue from "vue";
import Component from "vue-class-component";
import { Getter, Action } from "vuex-class";
import { Watch, Prop } from "vue-property-decorator";

import Schedule from "@/types/app/schedules";

const namespace = "customer";

@Component({})
export default class ScheduleFeedbackModal extends Vue {
  @Getter("getScheduleState", { namespace }) schedule!: Schedule;

  @Getter("getScheduleFeedbackModalState", { namespace })
  scheduleFeedbackModal!: boolean;
  @Action("setScheduleFeedbackModalState", { namespace })
  setScheduleFeedbackModalState!: any;

  @Prop(String) public readonly feedbackFlag!: string;

  refusing = false;
  successRefused = false;
  commentForRefuse = "";

  get schedulerName() {
    return `${this.schedule.firstName} ${this.schedule.lastName}'s`;
  }

  closeModal(): void {
    this.setScheduleFeedbackModalState(false);
  }
}
